import {
  TransferModel,
  TransferRequest,
} from '@src/core/domain/transfer/transfer.model';
import { Observable } from 'rxjs';

export abstract class TransferRepository {
  abstract addTransfer(params: TransferRequest): Observable<TransferModel>;
}
